import { notify } from 'utils/reduxUtils';

export const types = {
  ACTIVE_TAB_SET: 'contacts/searchPage/ACTIVE_TAB_SET',
  PAGINATE: 'contacts/searchPage/PAGINATE',
  SEARCH_ERROR: 'contacts/searchPage/SEARCH_ERROR',
  SEARCH_REQUEST: 'contacts/searchPage/SEARCH_REQUEST',
  SEARCH_SUCCESS: 'contacts/searchPage/SEARCH_SUCCESS',
  SEARCH_PAGE_INIT: 'contacts/searchPage/SEARCH_PAGE_INIT',
  SEARCH_PAGE_INIT_SUCCESS: 'contacts/searchPage/SEARCH_PAGE_INIT_SUCCESS',
  BULK_UPDATE_ACCOUNTS_DRAWER_OPEN:
    'contacts/searchPage/BULK_UPDATE_ACCOUNTS_DRAWER_OPEN',
  BULK_UPDATE_ACCOUNTS_DRAWER_CLOSE:
    'contacts/searchPage/BULK_UPDATE_ACCOUNTS_DRAWER_CLOSE',
};

export const activeTab = {
  set: ({ tab }) => ({
    type: types.ACTIVE_TAB_SET,
    payload: { tab },
  }),
};

export const paginate = {
  paginate: ({ pageNumber, filters }) => ({
    type: types.PAGINATE,
    payload: { pageNumber, filters },
  }),
};

export const search = {
  error: notify(
    (error) => ({
      type: types.SEARCH_ERROR,
      payload: error,
    }),
    'Failed to perform search',
  ),
  request: ({ query }) => ({
    type: types.SEARCH_REQUEST,
    payload: { query },
  }),
  success: ({ accounts, accountsCount, contacts, contactsCount, query }) => ({
    type: types.SEARCH_SUCCESS,
    payload: {
      accounts,
      accountsCount,
      contacts,
      contactsCount,
      query,
    },
  }),
};

export const searchPage = {
  init: ({ page, tab, query }) => ({
    type: types.SEARCH_PAGE_INIT,
    payload: { page, tab, query },
  }),
  success: ({ accounts, accountsCount, contacts, contactsCount }) => ({
    type: types.SEARCH_PAGE_INIT_SUCCESS,
    payload: {
      accounts,
      accountsCount,
      contacts,
      contactsCount,
    },
  }),
};

export const bulkUpdateAccountsDrawer = {
  open: () => ({
    type: types.BULK_UPDATE_ACCOUNTS_DRAWER_OPEN,
  }),
  close: () => ({
    type: types.BULK_UPDATE_ACCOUNTS_DRAWER_CLOSE,
  }),
};
